var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      ref: "sidebar-nav",
      staticClass: "sidebar-nav",
      attrs: { id: "sidebar-nav" }
    },
    [
      _c(
        "div",
        { staticClass: "OnlySideBar OutsideCss" },
        [
          _c(
            "nav",
            {
              class: [
                this.$route.path === "/dashboard"
                  ? "cg-menu-lateral"
                  : "cg-menu-lateral estreito"
              ]
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("ul", { staticClass: "cg-menu-apps" }, [
                _c(
                  "li",
                  {
                    class: [
                      this.$route.path === "/dashboard"
                        ? "start selected"
                        : "start"
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            return _vm.Dashboard()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "icone" }),
                        _vm._v(" "),
                        _vm._m(1)
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("li", { class: _vm.appClass(1, "nettool", "home") }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "javascript:void(0)",
                        id: "btnNettoolPRO"
                      },
                      on: {
                        click: function($event) {
                          return _vm.Home()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "icone" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "txt" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        this.isAppActive(1)
                          ? _c("p", [_vm._v("Ativo")])
                          : _vm._e(),
                        _vm._v(" "),
                        !this.isAppActive(1)
                          ? _c("p", [
                              _vm._v(
                                "Você ainda não ativou a NETtool. Quer saber como isso pode\n                beneficiar sua empresa?"
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "mappoint",
                    class: _vm.appClass(2, "mappoint")
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            return _vm.MapPoint()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "icone" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "txt" }, [
                          _c("h5", [_vm._v("MAPpoint")]),
                          _vm._v(" "),
                          this.isAppActive(2)
                            ? _c("p", [_vm._v("Ativo")])
                            : _vm._e(),
                          _vm._v(" "),
                          !this.isAppActive(2)
                            ? _c("p", [
                                _vm._v(
                                  "Você ainda não ativou a MAPpoint. Quer saber como isso pode\n                beneficiar sua empresa?"
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("li", { class: _vm.appClass(4, "apidados") }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.Apidados }
                    },
                    [
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "icone" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "txt" }, [
                        _c("h5", [_vm._v("API de dados")]),
                        _vm._v(" "),
                        this.isAppActive(4)
                          ? _c("p", [_vm._v("Ativo")])
                          : _vm._e(),
                        _vm._v(" "),
                        !this.isAppActive(4)
                          ? _c("p", [
                              _vm._v(
                                "Você ainda não ativou a API de Dados. Quer saber como isso\n                pode beneficiar sua empresa?"
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", { class: _vm.appClass(5, "smartleads") }, [
                  _c("a", { attrs: { href: "javascript:void(0)" } }, [
                    _c("span", { staticClass: "highlight" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "icone" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "txt" }, [
                      _c("h5", [_vm._v("SmartLeads")]),
                      _vm._v(" "),
                      !this.isAppActive(5)
                        ? _c("p", [
                            _vm._v(
                              "Você ainda não ativou o SmartLeads. Quer saber como isso\n                pode beneficiar sua empresa?"
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "cg-menu-apps" }, [
                _c(
                  "li",
                  {
                    class: [
                      this.$route.path === "/flow-sources" ||
                      this.$route.path === "/datalead"
                        ? "consumo selected"
                        : "consumo"
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: { click: _vm.DataLead }
                      },
                      [
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "icone" }),
                        _vm._v(" "),
                        _vm._m(3)
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: [
                      this.$route.path === "/upload"
                        ? "upload selected"
                        : "upload"
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { id: "btnUpload", href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            return _vm.Uploads()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "icone" }),
                        _vm._v(" "),
                        _vm._m(4)
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "cg-menu-servico" }, [
                _c("li", { class: _vm.appClass(6, "helpdesk") }, [_vm._m(5)]),
                _vm._v(" "),
                _c("li", { staticClass: "logout" }, [
                  _c(
                    "a",
                    {
                      attrs: { title: "Logout" },
                      on: {
                        click: function($event) {
                          return _vm.LogOff()
                        }
                      }
                    },
                    [_vm._m(6)]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          false
            ? _c(
                "div",
                { staticClass: "sidebar-container" },
                [
                  _c(
                    "b-row",
                    { staticClass: "sidebar-row" },
                    [
                      _c(
                        "b-col",
                        {
                          staticStyle: { "padding-top": "15px" },
                          attrs: { "align-self": "center" }
                        },
                        [
                          _c("b-navbar-brand", { attrs: { href: "home" } }, [
                            _c("img", {
                              attrs: {
                                src: require("../images/coglogo/Cognatis-menu-rgb.png"),
                                height: "38",
                                alt: "BV"
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", "align-self": "center" } },
                        [_c("span", { staticClass: "separator" })]
                      ),
                      _vm._v(" "),
                      false
                        ? _c(
                            "nav",
                            { staticClass: "user-nav sidebar-nav-itens" },
                            [
                              _c(
                                "li",
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover.left",
                                          value: {
                                            customClass: "menu-class",
                                            content: _vm.renderedUserText
                                          },
                                          expression:
                                            "{ customClass: 'menu-class', content: renderedUserText }",
                                          modifiers: { hover: true, left: true }
                                        }
                                      ],
                                      staticClass:
                                        "button1 collapsed nav-item no-padding",
                                      attrs: { id: "navButton1" },
                                      on: {
                                        mouseover: function($event) {
                                          return _vm.hoverIn("button1")
                                        },
                                        mouseout: function($event) {
                                          return _vm.hoverOut("button1")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "b-container",
                                        [
                                          _c("b-row", [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "20",
                                                  height: "20",
                                                  viewBox: "0 0 14 15",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  staticClass: "button1",
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d:
                                                      "M7 6C7.79565 6 8.55871 5.68393 9.12132 5.12132C9.68393 4.55871 10 3.79565 10 3C10 2.20435 9.68393 1.44129 9.12132 0.87868C8.55871 0.316071 7.79565 0 7 0C6.20435 0 5.44129 0.316071 4.87868 0.87868C4.31607 1.44129 4 2.20435 4 3C4 3.79565 4.31607 4.55871 4.87868 5.12132C5.44129 5.68393 6.20435 6 7 6ZM0 15C-1.36979e-08 14.0807 0.18106 13.1705 0.532843 12.3212C0.884626 11.4719 1.40024 10.7003 2.05025 10.0503C2.70026 9.40024 3.47194 8.88463 4.32122 8.53284C5.1705 8.18106 6.08075 8 7 8C7.91925 8 8.82951 8.18106 9.67879 8.53284C10.5281 8.88463 11.2997 9.40024 11.9497 10.0503C12.5998 10.7003 13.1154 11.4719 13.4672 12.3212C13.8189 13.1705 14 14.0807 14 15H0Z",
                                                    fill: "#6A707C"
                                                  }
                                                })
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-col", { attrs: { "align-self": "center" } }, [
                        _c("span", { staticClass: "separator" })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("nav", { staticClass: "sidebar-nav-itens" }, [
                _c(
                  "li",
                  [
                    _c(
                      "b-btn",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.left",
                            value: {
                              customClass: "menu-class",
                              content: "Mapas"
                            },
                            expression:
                              "{ customClass: 'menu-class', content: 'Mapas' }",
                            modifiers: { hover: true, left: true }
                          }
                        ],
                        staticClass: "button5 nav-item no-padding",
                        attrs: { id: "navButton3" },
                        on: {
                          click: function($event) {
                            return _vm.Home()
                          },
                          mouseover: function($event) {
                            return _vm.hoverIn("button5")
                          },
                          mouseout: function($event) {
                            return _vm.hoverOut("button5")
                          }
                        }
                      },
                      [
                        _c(
                          "b-container",
                          [
                            _c("b-row", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "16",
                                    height: "18",
                                    viewBox: "0 0 16 18",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d:
                                        "M10 0.585938L6 4.58594V17.4139L10 13.4139V0.585938ZM1.707 2.29294C1.56715 2.15313 1.38898 2.05792 1.19503 2.01935C1.00108 1.98079 0.800045 2.00059 0.617345 2.07626C0.434646 2.15193 0.278483 2.28007 0.168598 2.44448C0.0587141 2.60889 4.22243e-05 2.80219 0 2.99994V12.9999C5.66374e-05 13.2651 0.105451 13.5194 0.293 13.7069L4 17.4139V4.58594L1.707 2.29294ZM15.707 4.29294L12 0.585938V13.4139L14.293 15.7069C14.4328 15.8467 14.611 15.942 14.805 15.9805C14.9989 16.0191 15.2 15.9993 15.3827 15.9236C15.5654 15.8479 15.7215 15.7198 15.8314 15.5554C15.9413 15.391 16 15.1977 16 14.9999V4.99994C15.9999 4.73474 15.8945 4.48043 15.707 4.29294Z",
                                      fill: "#F58026"
                                    }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    false
                      ? _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.left",
                                value: {
                                  customClass: "menu-class",
                                  content: "Início"
                                },
                                expression:
                                  "{ customClass: 'menu-class', content: 'Início' }",
                                modifiers: { hover: true, left: true }
                              }
                            ],
                            staticClass:
                              "button4 collapsed nav-item no-padding",
                            on: {
                              click: _vm.debug,
                              mouseover: function($event) {
                                return _vm.hoverIn("button4")
                              },
                              mouseout: function($event) {
                                return _vm.hoverOut("button4")
                              }
                            }
                          },
                          [
                            _c(
                              "b-container",
                              [
                                _c("b-row", [
                                  _c("i", {
                                    staticClass: "fa-solid fa-database"
                                  })
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("b-col", { attrs: { cols: "12", "align-self": "center" } }, [
                _c("span", { staticClass: "separator" })
              ])
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("nav", { staticClass: "user-nav sidebar-nav-itens" }, [
                _c(
                  "li",
                  [
                    _c(
                      "b-btn",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.left",
                            value: {
                              customClass: "menu-class",
                              content: "Uploads"
                            },
                            expression:
                              "{ customClass: 'menu-class', content: 'Uploads' }",
                            modifiers: { hover: true, left: true }
                          }
                        ],
                        staticClass: "button2 collapsed nav-item no-padding",
                        attrs: { id: "navButton2" },
                        on: {
                          click: function($event) {
                            return _vm.Uploads()
                          },
                          mouseover: function($event) {
                            return _vm.hoverIn("button2")
                          },
                          mouseout: function($event) {
                            return _vm.hoverOut("button2")
                          }
                        }
                      },
                      [
                        _c(
                          "b-container",
                          [
                            _c("b-row", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M5.4998 13.0003C4.60432 12.9991 3.74336 12.6548 3.09407 12.0381C2.44478 11.4214 2.05655 10.5793 2.00928 9.68508C1.96201 8.79086 2.25928 7.91252 2.83993 7.23082C3.42058 6.54911 4.24044 6.1159 5.1308 6.02031C4.86863 4.9922 5.02562 3.90205 5.56722 2.98969C6.10883 2.07732 6.99068 1.41748 8.0188 1.15531C9.04691 0.893143 10.1371 1.05013 11.0494 1.59174C11.9618 2.13334 12.6216 3.0152 12.8838 4.04331C13.4952 3.95817 14.1177 3.99976 14.7124 4.16547C15.307 4.33119 15.8613 4.6175 16.3406 5.00659C16.8199 5.39568 17.214 5.87923 17.4984 6.42716C17.7828 6.97508 17.9514 7.57567 17.9938 8.19156C18.0361 8.80745 17.9513 9.42547 17.7446 10.0072C17.5379 10.5889 17.2137 11.1218 16.7921 11.5729C16.3706 12.0239 15.8608 12.3834 15.2944 12.629C14.728 12.8745 14.1171 13.0009 13.4998 13.0003H10.9998V9.41331L12.2928 10.7063C12.4814 10.8885 12.734 10.9893 12.9962 10.987C13.2584 10.9847 13.5092 10.8795 13.6946 10.6941C13.88 10.5087 13.9852 10.2579 13.9875 9.99571C13.9897 9.73351 13.889 9.48091 13.7068 9.29231L10.7068 6.29231C10.5193 6.10484 10.265 5.99952 9.9998 5.99952C9.73463 5.99952 9.48032 6.10484 9.2928 6.29231L6.2928 9.29231C6.11064 9.48091 6.00984 9.73351 6.01212 9.99571C6.0144 10.2579 6.11957 10.5087 6.30498 10.6941C6.49039 10.8795 6.7412 10.9847 7.00339 10.987C7.26559 10.9893 7.51819 10.8885 7.7068 10.7063L8.9998 9.41431V13.0003H5.4998Z",
                                      fill: "#6A707C"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M9 13H11V18C11 18.2652 10.8946 18.5196 10.7071 18.7071C10.5196 18.8946 10.2652 19 10 19C9.73478 19 9.48043 18.8946 9.29289 18.7071C9.10536 18.5196 9 18.2652 9 18V13Z",
                                      fill: "#6A707C"
                                    }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "b-btn",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.left",
                            value: {
                              customClass: "menu-class",
                              content: "Consumo"
                            },
                            expression:
                              "{ customClass: 'menu-class', content: 'Consumo' }",
                            modifiers: { hover: true, left: true }
                          }
                        ],
                        staticClass: "button3 collapsed nav-item no-padding",
                        on: {
                          mouseover: function($event) {
                            return _vm.hoverIn("button3")
                          },
                          click: _vm.toggleModal,
                          mouseout: function($event) {
                            return _vm.hoverOut("button3")
                          }
                        }
                      },
                      [
                        _c(
                          "b-container",
                          [
                            _c("b-row", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M5.83333 9.99968L8.33333 7.49967L10.8333 9.99968L14.1667 6.66634M2.5 3.33301H17.5M6.66667 17.4997L10 14.1663L13.3333 17.4997H6.66667ZM3.33333 3.33301H16.6667V13.333C16.6667 13.554 16.5789 13.766 16.4226 13.9223C16.2663 14.0785 16.0543 14.1663 15.8333 14.1663H4.16667C3.94565 14.1663 3.73369 14.0785 3.57741 13.9223C3.42113 13.766 3.33333 13.554 3.33333 13.333V3.33301Z",
                                      stroke: "#6A707C",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("nav", { staticClass: "sidebar-nav-itens" }, [
            false
              ? _c(
                  "li",
                  [
                    _c(
                      "b-btn",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.left",
                            value: {
                              customClass: "menu-class",
                              content: "Filtro Básico de Empresas"
                            },
                            expression:
                              "{ customClass: 'menu-class', content: 'Filtro Básico de Empresas' }",
                            modifiers: { hover: true, left: true }
                          }
                        ],
                        staticClass: "button7 collapsed nav-item no-padding",
                        attrs: { id: "popover-button-7" },
                        on: {
                          click: function($event) {
                            return _vm.FiltroBasico()
                          },
                          mouseover: function($event) {
                            return _vm.hoverIn("button7")
                          },
                          mouseout: function($event) {
                            return _vm.hoverOut("button7")
                          }
                        }
                      },
                      [
                        _c(
                          "b-container",
                          [
                            _c("b-row", [
                              _c(
                                "svg",
                                {
                                  staticStyle: { "margin-left": "2px" },
                                  attrs: {
                                    width: "14",
                                    height: "16",
                                    viewBox: "0 0 14 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d:
                                        "M1 2C1 1.46957 1.21071 0.960859 1.58579 0.585786C1.96086 0.210714 2.46957 0 3 0H11C11.5304 0 12.0391 0.210714 12.4142 0.585786C12.7893 0.960859 13 1.46957 13 2V14C13.2652 14 13.5196 14.1054 13.7071 14.2929C13.8946 14.4804 14 14.7348 14 15C14 15.2652 13.8946 15.5196 13.7071 15.7071C13.5196 15.8946 13.2652 16 13 16H10C9.73479 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V13C9 12.7348 8.89464 12.4804 8.70711 12.2929C8.51957 12.1054 8.26522 12 8 12H6C5.73478 12 5.48043 12.1054 5.29289 12.2929C5.10536 12.4804 5 12.7348 5 13V15C5 15.2652 4.89464 15.5196 4.70711 15.7071C4.51957 15.8946 4.26522 16 4 16H1C0.734784 16 0.48043 15.8946 0.292893 15.7071C0.105357 15.5196 0 15.2652 0 15C0 14.7348 0.105357 14.4804 0.292893 14.2929C0.48043 14.1054 0.734784 14 1 14V2ZM4 3H6V5H4V3ZM6 7H4V9H6V7ZM8 3H10V5H8V3ZM10 7H8V9H10V7Z",
                                      fill: "#6A707C"
                                    }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isCog
              ? _c("li", [
                  _c(
                    "div",
                    {
                      staticClass: "cog",
                      style: { backgroundColor: _vm.cogColor },
                      on: {
                        mouseover: function($event) {
                          _vm.showText = true
                        },
                        mouseleave: function($event) {
                          _vm.showText = false
                        }
                      }
                    },
                    [
                      _vm.showText
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.envTag) +
                                " - " +
                                _vm._s(_vm.EnvironmentAlias) +
                                " "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("nav", { staticClass: "user-nav sidebar-nav-itens" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "my-modal",
          attrs: { "hide-footer": "", size: "xl", title: "Consumo" }
        },
        [
          _c(
            "div",
            { staticClass: "d-block text-center" },
            [_vm.showLeadManager ? _c("LeadManager") : _vm._e()],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cg-menu-logo" }, [
      _c(
        "a",
        {
          staticClass: "logo",
          attrs: { href: "https://www.cognatis.com.br", target: "_blank" }
        },
        [_vm._v(" ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txt" }, [_c("h5", [_vm._v("Início")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _vm._v("NETtool"),
      _c("sup", [_vm._v("®")]),
      _vm._v(" Pro")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txt" }, [
      _c("h5", [_vm._v("Consumo de Dados Premium")]),
      _vm._v(" "),
      _c("p", [_vm._v("Ativo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txt" }, [_c("h5", [_vm._v("Upload")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://cognatis.screenstepslive.com/s/13101",
          title: "Helpdesk",
          target: "_blank",
          rel: "noopener"
        }
      },
      [
        _c("div", [
          _c("span", { staticClass: "icone" }),
          _vm._v(" "),
          _c("div", { staticClass: "txt" }, [_c("h5", [_vm._v("Helpdesk")])])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "icone" }),
      _vm._v(" "),
      _c("div", { staticClass: "txt" }, [_c("h5", [_vm._v("Logout")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }